import { FC } from "react";
import { includes } from "lodash";

import { EMPTY_VALUE_PLACEHOLDER } from "constants/index";
import { formatCurrencyAmount, formatNumber } from "lib/format";
import { InventoryListing } from "services/inventory/types";
import { LISTING_DEAL_STATES } from "services/listings/constants";
import theme from "theme";

const ListPriceOrSalePrice: FC<{
  listing: InventoryListing;
}> = ({ listing }) => {
  const isListingOpen = !includes(
    [...LISTING_DEAL_STATES, "closed"],
    listing.state,
  );

  const liveAuctionPrice = !!listing.highest_open_offer_amount
    ? listing.highest_open_offer_amount
    : listing.list_price;

  const isAcceptingFinalOffers = listing.state === "accepting_final_offers";

  const listPriceOrSalePrice =
    listing.state === "live"
      ? liveAuctionPrice
      : isAcceptingFinalOffers
      ? listing.highest_open_offer_amount
      : isListingOpen
      ? listing.list_price
      : listing.deal_amount;

  const listPriceOrSalePriceStyle = isListingOpen
    ? undefined
    : { color: theme.custom.palette.softRed.main };

  const listPriceOrSalePriceFormatted = listPriceOrSalePrice
    ? formatCurrencyAmount(listing.currency, listPriceOrSalePrice)
    : EMPTY_VALUE_PLACEHOLDER;

  const multipleFormatted =
    !!listing.converted_deal_amount_or_list_price && !!Number(listing.ltm)
      ? ` (${formatNumber(
          Number(listing.converted_deal_amount_or_list_price) /
            Number(listing.ltm),
          "",
          2,
        )}x)`
      : "";
  return (
    <>
      <span style={listPriceOrSalePriceStyle}>
        {listPriceOrSalePriceFormatted}
      </span>
      <span
        style={{
          fontSize: "0.75rem",
          color: theme.custom.palette.gray.dark,
        }}
      >
        {multipleFormatted}
      </span>
    </>
  );
};

export default ListPriceOrSalePrice;
